export enum LanguageId {
  Swedish = 1,
  Danish = 2,
  Finnish = 4,
  Norwegian = 6,
  French = 65,
  Dutch = 151,
  Spanish = 198,
  English = 200,
  German = 221,
}

export type Language = {
  id: LanguageId
  label: string
  locale: string
}

export const languages: Language[] = [
  { id: LanguageId.Danish, label: 'Danish', locale: 'da-DK' },
  { id: LanguageId.Dutch, label: 'Dutch', locale: 'nl-NL' },
  { id: LanguageId.English, label: 'English', locale: 'en-GB' },
  { id: LanguageId.Finnish, label: 'Finnish', locale: 'fi-FI' },
  { id: LanguageId.French, label: 'French', locale: 'fr-FR' },
  { id: LanguageId.German, label: 'German', locale: 'de-DE' },
  { id: LanguageId.Norwegian, label: 'Norwegian', locale: 'nn-NO' },
  { id: LanguageId.Spanish, label: 'Spanish', locale: 'es-ES' },
  { id: LanguageId.Swedish, label: 'Swedish', locale: 'sv-SE' },
]
